import AtividadesExtra from "../AtividadesExtra/AtividadesExtra";
import BoletimHeader from "../BoletimHeader/BoletimHeader";
import Comunidades from "../Comunidades/Comunidades";
import DadosPessoais from "../DadosPessoais/DadosPessoais";
import Esportes from "../Esportes/Esportes";
import Estagio from "../Estagio/Estagio";
import ExperienciaInternacional from "../ExperienciaInternacional/ExperienciaInternacional";
import Ingles from "../Ingles/Ingles";
import LinkLabs from "../LinkLabs/LinkLabs";
import LinkPulse from "../LinkPulse/LinkPulse";
import MediaTurmaAluno from "../MediaTurmaAluno/MediaTurmaAluno";
import NotasSemestre from "../NotasSemestre/NotasSemestre";
import StartupSchool from "../StartupSchool/StartupSchool";
import Ventures from "../Ventures/Ventures";

import DesafioPratico from "../DesafioPratico/DesafioPratico";
import Nivelamento from "../Nivelamento/Nivelamento";
import styles from "./Boletim.module.css";
import Loader from "./Loader/Loader";

function Boletim({ pdfTargetRef, boletim, period, isLoading }) {
	return (
		<div
			className={styles.container}
			ref={pdfTargetRef}
		>
			<BoletimHeader period={period} />
			{isLoading && <Loader />}
			{!isLoading && boletim && (
				<>
					<DadosPessoais student={boletim.personal} />
					<ExperienciaInternacional
						experiencias={boletim.international_affairs.programs}
						highlight={boletim.international_affairs.highlights}
					/>
					<NotasSemestre
						final_grade={boletim.grades.general.grade}
						freq={boletim.grades.general.freq}
						ranking={boletim.grades.general.rank}
						subjects_grades={boletim.grades.grades_by_subject}
						showAol={boletim.grades?.showAol}
						showNp={boletim.grades?.showNp}
					/>
					<MediaTurmaAluno
						subjects_grades={boletim.grades.grades_by_subject}
					/>
                    {boletim?.practical_challenge && boletim?.practical_challenge.grades.length > 0 && <DesafioPratico group={boletim?.practical_challenge.group} challenge={boletim?.practical_challenge.challenge} challenges_grades={boletim?.practical_challenge.grades} />}
					<AtividadesExtra atividades={boletim.extra_activities} />
					{boletim.show_internship && (
						<Estagio internship={boletim.internship} />
					)}
					<Ingles english={boletim.english} />
                    {boletim?.nivelamentos && <Nivelamento nivelamentos={boletim?.nivelamentos} />}
					<LinkLabs linkLabs={boletim.link_labs} student_success={boletim?.student_success} />
					<Comunidades comunidades={boletim.communities} lider={boletim?.communities_leader} />
					<Esportes esportes={boletim.sports} />
					<LinkPulse pulse={boletim.link_pulse} />
					<Ventures ventures={boletim.ventures} />
					<StartupSchool startup_school={boletim.startup_school} />
				</>
			)}
			{!isLoading && !boletim && (
				<div className={styles.errorContainer}>
					<div className={styles.errorBody}>
						Não foi possível encontrar o aluno ou o RA consultado
						está incorreto.
					</div>
				</div>
			)}
		</div>
	);
}

export default Boletim;
